// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  devel: false,
  webapp_client_id: '850683581429-ankv6b9gnlf633mqj27r62kcdf1g2jq6.apps.googleusercontent.com',
  zoom_client_id: '11nQvWmnRAelhjA4M1JaBA',
  zoom_sdk_key: '1iUMA6r5rMJBtEo2eSu5xmPG6djCdMAnUflV',
  firebase: {
    apiKey: "AIzaSyBOIFdWxPexMmII_vDFqO4saYPfBPw4JMw",
    authDomain: "esoteric-storm-368912.firebaseapp.com",
    databaseURL: "https://esoteric-storm-368912-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "esoteric-storm-368912",
    storageBucket: "esoteric-storm-368912.appspot.com",
    messagingSenderId: "850683581429",
    appId: "1:850683581429:web:0d4ffc272e0c7b3fa806bc"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
